<template>
  <div
    v-if="showView"
    id="signPadView"
  >
    <div class="signPad-wrap">
      <canvas id="signPad" />
    </div>
    <div class="sign-btn">
      <h2>請住戶於簽名板上簽名</h2>
      <div class="btn-wrap">
        <el-button @click="exitBtn">
          離開(Esc鍵)
        </el-button>
        <el-button
          icon="glyphicon-remove"
          type="danger"
          @click="cleanSignPad"
        >
          清除重簽
        </el-button>
        <el-button
          type="success"
          @click="saveSign"
        >
          儲存簽名檔(Enter鍵)
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad'
export default {
  data () {
    return {
      showView: false,
      signaturePad: null,
      callback: Function
    }
  },
  mounted () {

  },
  methods: {
    init () {
      window.addEventListener('resize', this.reportWindowSize)
      window.addEventListener('keydown', this.KeyboardEvent)
      this.showView = true
      this.$nextTick(() => {
        this._fullScreen()
        const signPad = document.getElementById('signPad')
        signPad.width = document.querySelector('#signPadView .signPad-wrap').offsetWidth - 10
        signPad.height = document.querySelector('#signPadView .signPad-wrap').offsetHeight - 10
        setTimeout(() => {
          this.signaturePad = new SignaturePad(signPad, {
            backgroundColor: 'rgba(0, 0, 0)',
            penColor: 'rgb(255, 255, 255)'
          })
        }, 800)
      })
    },
    getSign (cbf) {
      this.callback = cbf
      this.init()
    },
    _fullScreen: function () {
      const docElm = document.documentElement
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen()
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      }
    },
    _cancelFullScreen: function () {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    },
    exitBtn () {
      window.removeEventListener('resize', this.reportWindowSize)
      window.removeEventListener('keydown', this.KeyboardEvent)
      this._cancelFullScreen()
      this.showView = false
      this.signaturePad = null
      this.callback = Function
    },
    reportWindowSize () {
      const signPad = document.getElementById('signPad')
      const signPadWrap = document.querySelector('#signPadView .signPad-wrap')
      if (signPad.height < signPadWrap.offsetHeight || signPad.width < signPadWrap.offsetWidth) {
        signPad.width = document.querySelector('#signPadView .signPad-wrap').offsetWidth
        signPad.height = document.querySelector('#signPadView .signPad-wrap').offsetHeight
      } else {
        this.exitBtn()
      }
    },
    cleanSignPad () {
      this.signaturePad.clear()
    },
    KeyboardEvent (e) {
      console.log(e.keyCode)
      // eslint-disable-next-line eqeqeq
      if (e.keyCode == 13) this.saveSign()
    },
    saveSign () {
      if (!this.signaturePad.isEmpty()) this.callback(this.signaturePad.toDataURL('base64'))
      this.exitBtn()
    }
  }
}
</script>

<style lang="sass" scoped>
  #signPadView
    position: fixed
    height: 100%
    width: 100%
    z-index: 200001
    top: 0
    padding: 10px
    background-color: #000
    box-sizing: border-box
    .signPad-wrap
      height: 90%
      width: 100%
      position: relative
      &:after
        content: '簽名預覽'
        background-color: #e5e5e5
        color: #5f5f5f
        font-size: 30px
        padding: 5px 12px
        border-bottom-right-radius: 5px
        position: absolute
        top: 0
        left: 0
      canvas
        border: 3px solid #d5d5d5
        border-radius: 5px
    .sign-btn
      display: flex
      justify-content: space-between
      h2
        color: #fff
        font-weight: bold
        font-size: 30px
        margin: 20px 0 10px 0
      .btn-wrap
        margin-top: 20px
</style>
